import React, { useState, useEffect } from "react";
import { Button, Col, Row, Table, Form, Container } from "react-bootstrap";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import { ToastContainer, toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import categoryService from "../../service/categoryService";
import { ThreeDotSpinner } from "../../common/loader/loader";
import {image} from "../../assets/images/no-data-bg.gif"

const CategoryManagement = () => {
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [editCategoryId, setEditCategoryId] = useState(null);
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 10, pageRange: 0, totalCount: 0 })
  const [Loader , setLoader] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, [pagination.pageNumber]);

  const fetchCategories = async () => {
    setLoader(true);
    const params = { page: pagination.pageNumber - 1, size: pagination.pageSize }
    const response = await categoryService.filter(params)

    if (response.status == 200) {
      setCategories(response.data.data.categories)
      setPagination({
        ...pagination,
        totalCount: response.data.data.count
      })
    }
    setLoader(false);
  };

  const handlePageChange = (pageNumber) => {
    setPagination({
      ...pagination,
      pageNumber: pageNumber
    })
  };

  const handleInputChange = (e) => {
    setCategoryName(e.target.value);
  };

  const handleSubmit = async() => {
    if (!categoryName.trim()) {
      toast.error("Category name is required.");
      return;
    }

    // to update exisitng category
    if (editCategoryId) {
      const res = await categoryService.update({"name":categoryName},{"id" :editCategoryId});   
      if(res.status === 200){
        toast.success(res.data.message);
        fetchCategories();
      }
    // to add new category
    } else {
      const res = await categoryService.create({"name":categoryName});
      if(res.status == 200){
        fetchCategories();
        toast.success(res.data.message);
      }
    }
    setCategoryName("");
    setEditCategoryId(null);
  };

  const handleDelete = async (id) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });
  
    if (willDelete) {
        const res = await categoryService.delete(id); 
        if (res.status === 200) {
          toast.success(res.data.message);
          await fetchCategories();
        }
      } 
  };

  const handleEdit = (category) => {
    setCategoryName(category.name);
    setEditCategoryId(category._id);
  };

return (  
  <div className="dashboard-main-area">
      {Loader && <ThreeDotSpinner />}

      <Container fluid>
        <div className="dashboard-area-heading management-heading">
          <Row className="justify-content-center align-items-center mb-2">
            <Col md={12}>
              <div className="d-flex justify-content-between mb-2">
                <h2 className="m-0">Category Management</h2>
              </div>
            </Col>
          </Row>

          <Row>
            {/* Category List Section */}
            <Col md={8}>
              <div className="category-list">
                <Table responsive striped bordered>
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.length > 0 ? (
                      categories.map((cat, index) => (
                        <tr key={cat.id}>
                          <td>{(pagination.pageNumber - 1) * pagination.pageSize + index + 1}</td>
                          <td>{cat.name}</td>
                          <td>
                            <Button className="edit-button"
                              size="sm"
                              onClick={() => handleEdit(cat)}
                            >
                              Edit
                            </Button>{" "}
                            <Button
                              className="delete-button"
                              variant="danger"
                              size="sm"
                              onClick={() => handleDelete(cat._id)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                        <img src="/assets/images/no-data-bg.gif" alt="No Data" width="50" />
                        <p>No categories found</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                {/* Pagination */}
                {categories.length > 0 && pagination.totalCount > pagination.pageSize && (
                  <Pagination
                    activePage={pagination.pageNumber}
                    itemsCountPerPage={pagination.pageSize}
                    totalItemsCount={pagination.totalCount}
                    pageRangeDisplayed={pagination.pageRange}
                    onChange={(e) => handlePageChange(e)}
                    prevPageText={"Prev"}
                    nextPageText={"Next"}
                  />
                )}
              </div>
            </Col>

            {/* Add/Edit Category Section */}
            <Col md={4}>
              <div className="category-form">
                <h3>{editCategoryId ? "Edit Category" : "Add Category"}</h3>
                
                <div className='login-fiels-outer'>
                  <div className='login-fields-inner'>
                    <Form.Group>
                      <Form.Control
                        className="category-edit"
                        type="text"
                        value={categoryName}
                        onChange={handleInputChange}
                        placeholder="Enter category name"
                      />
                    </Form.Group>
                  </div>
                </div>
                <Button
                  variant="primary"
                  className="mt-3 w-100"
                  style={{ backgroundColor: "#003FE6" }}
                  onClick={handleSubmit}
                >
                  {editCategoryId ? "Update" : "Add"}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default CategoryManagement;
